<template>
    <div class="container create-order-wrap px-2 py-2 border">
        <div class="title-wrap border-bottom mb-3">
            <h1 v-if="!orderId">{{$ml.with('VueJS').get('CreateOrder')}}</h1>
            <h1 v-else>{{$ml.with('VueJS').get('UpdateOrder')}}</h1>
        </div>

        <div class="form-wrap">
            <div class="alert alert-warning">Все поля обязательны для заполнения</div>

            <div class="select-pharmacy-network-wrap mb-2 col-12">
                <model-select :options="pharmacyNetworksList"
                              v-model="selectedPharmacyNetworkId"
                              placeholder="Выберите аптечную сеть"
                >
                </model-select>
            </div>
            <div class="select-pharmacy-network-rekvizit-wrap mb-2 col-12">
                <b-form-select v-model="selectedFirmRekvizit" @change="fillRekvizits">
                    <b-form-select-option :value="null">Выберите платежные реквизиты</b-form-select-option>
                    <b-form-select-option v-for="option in firmRekvizits" v-bind:key="option.id" :value="option.id">
                        {{option.bank_name}} ({{option.rs}})
                    </b-form-select-option>
                </b-form-select>
            </div>

            <div class="payer-params d-flex flex-wrap mb-2">
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-title"
                            label=""
                            label-for="input-payer-title"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-title"
                                v-model="payerParams.title"
                                placeholder="Наименование плательщика"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-address"
                            label=""
                            label-for="input-payer-address"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-address"
                                v-model="payerParams.address"
                                placeholder="Адрес"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group
                            id="input-group-payer-inn"
                            label=""
                            label-for="input-payer-inn"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-inn"
                                v-model="payerParams.inn"
                                placeholder="ИНН плательщика"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group
                            id="input-group-payer-kpp"
                            label=""
                            label-for="input-payer-kpp"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-kpp"
                                v-model="payerParams.kpp"
                                placeholder="КПП плательщика"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group
                            id="input-group-payer-ogrn"
                            label=""
                            label-for="input-payer-ogrn"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-ogrn"
                                v-model="payerParams.ogrn"
                                placeholder="ОГРН плательщика"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-bik"
                            label=""
                            label-for="input-payer-bik"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-bik"
                                v-model="payerParams.bik"
                                placeholder="БИК Банка"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-bank"
                            label=""
                            label-for="input-payer-bank"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-bank"
                                v-model="payerParams.bank"
                                placeholder="Банк"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-corr_s"
                            label=""
                            label-for="input-payer-corr_s"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-corr_s"
                                v-model="payerParams.corr_s"
                                placeholder="Кор. счет"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-rs"
                            label=""
                            label-for="input-payer-rs"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-rs"
                                v-model="payerParams.rs"
                                placeholder="р\сч."
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-phone"
                            label=""
                            label-for="input-payer-phone"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-phone"
                                v-model="payerParams.phone"
                                type="tel"
                                placeholder="Телефон"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-payer-email"
                            label=""
                            label-for="input-payer-email"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-email"
                                v-model="payerParams.email"
                                type="email"
                                placeholder="Email"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-payer-manager_name"
                            label=""
                            label-for="input-payer-manager_name"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-manager_name"
                                v-model="payerParams.manager_name"
                                placeholder="ФИО ответственного лица"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-payer-manager_name_akk"
                            label=""
                            label-for="input-payer-manager_name_akk"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-manager_name_akk"
                                v-model="payerParams.manager_name_akk"
                                placeholder="ФИО ответсвенного лица (АКК)"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-payer-manager_position"
                            label=""
                            label-for="input-payer-manager_position"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-manager_position"
                                v-model="payerParams.manager_position"
                                placeholder="Должность"
                                class="important-field"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-payer-manager_position_akk"
                            label=""
                            label-for="input-payer-manager_position_akk"
                            description=""
                    >
                        <b-form-input
                                id="input-payer-manager_position_akk"
                                v-model="payerParams.manager_position_akk"
                                placeholder="Должность (АКК)"
                                class="important-field"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12">
                    <b-form-group
                            id="input-group-shipping-address"
                            label-for="input-shipping-address"
                            description=""
                            class="mb-2"
                    >
                        <b-form-textarea
                                id="input-shipping-address"
                                v-model="shippingAddress"
                                placeholder="Адрес доставки"
                                rows="3"
                                max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </div>

            <div class="select-pc-rekvizit-wrap mb-2 col-12">
                <b-form-select v-model="selectedPcRekvizit"
                               @change="fillPcRekvizits">
                    <b-form-select-option :value="null">Выберите реквизиты ФК</b-form-select-option>
                    <b-form-select-option :value="index" v-for="(rekvizit, index) in pharmCompanyRekvizits" v-bind:key="index">
                        {{rekvizit.pharmcompany_name}}
                    </b-form-select-option>
                </b-form-select>
            </div>
            <div class="pc_rekvizits-params d-flex flex-wrap mb-2">
                <div class="col-md-12">
                    <b-form-group
                            id="input-group-pc_rekvizit-name"
                            label=""
                            label-for="input-pc_rekvizit-name"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizit-name"
                                v-model="pcRekvizitParams.pharmcompany_name"
                                placeholder="Наименование ФК"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-address_ur"
                            label=""
                            label-for="input-pc_rekvizits-address_ur"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-address_ur"
                                v-model="pcRekvizitParams.pharmcompany_address_ur"
                                placeholder="Юридический адрес"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-address_post"
                            label=""
                            label-for="input-pc_rekvizits-address_post"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-address_post"
                                v-model="pcRekvizitParams.pharmcompany_address_post"
                                placeholder="Почтовый адрес"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-director"
                            label=""
                            label-for="input-pc_rekvizits-director"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-director"
                                v-model="pcRekvizitParams.pharmcompany_director"
                                placeholder="Директор"
                                class="important-field"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-director_akk"
                            label=""
                            label-for="input-pc_rekvizits-director_akk"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-director_akk"
                                v-model="pcRekvizitParams.pharmcompany_director_akk"
                                placeholder="Директор (АКК)"
                                class="important-field"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-director_occupation"
                            label=""
                            label-for="input-pc_rekvizits-director_occupation"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-director_occupation"
                                v-model="pcRekvizitParams.pharmcompany_director_occupation"
                                placeholder="Должность представителя ФК"
                                class="important-field"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-chief_accountant"
                            label=""
                            label-for="input-pc_rekvizits-chief_accountant"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-chief_accountant"
                                v-model="pcRekvizitParams.pharmcompany_chief_accountant"
                                placeholder="ФИО главбуха"
                                class="important-field"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-inn"
                            label=""
                            label-for="input-pc_rekvizits-inn"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-inn"
                                v-model="pcRekvizitParams.pharmcompany_inn"
                                placeholder="ИНН"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-kpp"
                            label=""
                            label-for="input-pc_rekvizits-kpp"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-kpp"
                                v-model="pcRekvizitParams.pharmcompany_kpp"
                                placeholder="КПП"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-ogrnip"
                            label=""
                            label-for="input-pc_rekvizits-ogrnip"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-ogrnip"
                                v-model="pcRekvizitParams.pharmcompany_ogrnip"
                                placeholder="ОГРНИП"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group
                            id="input-group-pc_rekvizits-ogrn"
                            label=""
                            label-for="input-pc_rekvizits-ogrn"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-ogrn"
                                v-model="pcRekvizitParams.pharmcompany_ogrn"
                                placeholder="ОГРН"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-tel"
                            label=""
                            label-for="input-pc_rekvizits-tel"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-tel"
                                v-model="pcRekvizitParams.pharmcompany_tel"
                                placeholder="Телефон"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-email"
                            label=""
                            label-for="input-pc_rekvizits-email"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-email"
                                v-model="pcRekvizitParams.pharmcompany_email"
                                placeholder="Email"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-bik"
                            label=""
                            label-for="input-pc_rekvizits-bik"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-bik"
                                v-model="pcRekvizitParams.pharmcompany_bik"
                                placeholder="БИК"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-bank_name"
                            label=""
                            label-for="input-pc_rekvizits-bank_name"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-bank_name"
                                v-model="pcRekvizitParams.pharmcompany_bank_name"
                                placeholder="Наименование банка"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-corr_account"
                            label=""
                            label-for="input-pc_rekvizits-corr_account"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-corr_account"
                                v-model="pcRekvizitParams.pharmcompany_corr_account"
                                placeholder="К/сч."
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-group-pc_rekvizits-bank_account"
                            label=""
                            label-for="input-pc_rekvizits-bank_account"
                            description=""
                    >
                        <b-form-input
                                id="input-pc_rekvizits-bank_account"
                                v-model="pcRekvizitParams.pharmcompany_bank_account"
                                placeholder="Р/сч."
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-datepicker
                            id="input-order_date"
                            v-model="orderDate"
                            locale="ru"
                            start-weekday="1"
                            :labels="datePickerLabels"
                            label-no-date-selected="Использовать текущую дату"
                            @input="changeOrderDate"
                    ></b-form-datepicker>
                </div>
                <div class="col-md-6">
                    <b-form-group
                            id="input-payment_way"
                            label=""
                            label-for="input-payment_way"
                            description=""
                    >
                        <b-form-input
                                id="input-payment_way"
                                v-model="paymentWay"
                                placeholder="% предоплаты"
                        ></b-form-input>
                    </b-form-group>
                    <div class="alert alert-warning" v-if="paymentWay == '50%'">
                        50% от общей стоимости заказа в течение 10 дней с момента получения счета, остальная часть в течение 10 дней после получения товара
                    </div>
                    <div class="alert alert-warning" v-if="paymentWay == '100%'">
                        100% от общей стоимости заказа в течение 10 дней с момента получения счета
                    </div>
                    <div class="alert alert-warning" v-if="paymentWay == '0%'">
                        100% от общей стоимости заказа в течение 10 дней после получения товара.
                    </div>

                    <div class="options-wrap mb-1">
                        <a @click="paymentWay = '50%'" class="btn btn-info mr-1 btn-sm">50%</a>
                        <a @click="paymentWay = '100%'" class="btn btn-info mr-1 btn-sm">100%</a>
                        <a @click="paymentWay = '0%'" class="btn btn-info mr-1 btn-sm">постоплата</a>
                    </div>
                </div>

            </div>



            <div class="selected-items-wrap mb-2">
                <div class="select-wrap d-flex flex-wrap" v-for="(selectedProduct, index) in selectedProducts" v-bind:key="index">
                    <div class="col-md-6 mb-2">
                        <model-select :options="filteredProductsList"
                                      v-model="selectedProducts[index].good_id"
                                      placeholder="Выберите продукт">
                        </model-select>
                    </div>
                    <div class="col-md-3 mb-2">
                        <b-form-group
                                :id="'input-group-' + index + '-quantity'"
                                label=""
                                :label-for="'input-' + index + '-quantity'"
                                description=""
                        >
                            <b-form-input
                                    :id="'input-' + index + '-quantity'"
                                    v-model="selectedProducts[index].quantity"
                                    type="number"
                                    placeholder="Кол-во"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-3 mb-2">
                        <b-form-group
                                :id="'input-group-' + index + '-product_discount'"
                                label=""
                                :label-for="'input-' + index + '-product_discount'"
                                description=""
                        >
                            <b-form-input
                                    :id="'input-' + index + '-product_discount'"
                                    v-model="selectedProducts[index].product_discount_text"
                                    @change="onDiscountChange(index)"
                                    type="number"
                                    placeholder="Скидка"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="mb-2">
                <b-button @click="addNewProduct()" variant="info" class="mr-2" v-if="!orderId">
                    {{$ml.with('VueJS').get('AddProduct')}}
                </b-button>
                <b-button @click="createOrder()" variant="success" v-if="!orderId">
                    {{$ml.with('VueJS').get('CreateOrderLink')}}
                </b-button>
                <b-button @click="updateOrder()" variant="success" v-else>
                    {{$ml.with('VueJS').get('UpdateOrderLink')}}
                </b-button>
            </div>
        </div>
    </div>
</template>
<style>
    .important-field {
        border-color: #ffeeba;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 243, 205,.25);
        box-shadow: 0 0 0 0.2rem rgba(255, 243, 205,.25);
    }
</style>

<script>
  import {ModelSelect} from 'vue-search-select'
  import mixinUtils from "@/components/mixinUtils"
  import {pharmCompanyRekvizits} from "@/helpers/variables"

  export default {
    name: 'create-order',
    mixins: [mixinUtils],
    components: {
        ModelSelect,
    },
    data: () => ({
      orderId: null,
      pharmacyNetworksList: [],
      firmRekvizits: [],
      pharmCompanyRekvizits: pharmCompanyRekvizits,
      selectedPharmacyNetworkId: null,
      selectedFirmRekvizit: null,
      selectedPcRekvizit: null,
      productsList: [],
      selectedProducts: [],
      shippingAddress: null,
      payerParams: {
        title: null,
        address: null,
        inn: null,
        kpp: null,
        ogrn: null,
        bik: null,
        bank: null,
        corr_s: null,
        rs: null,
        phone: null,
        email: null,
        manager_name: null,
        manager_name_akk: null,
        manager_position: null,
        manager_position_akk: null,
      },
      pcRekvizitParams: {
        pharmcompany_name: null,
        pharmcompany_director: null,
        pharmcompany_director_akk: null,
        pharmcompany_director_occupation: null,
        pharmcompany_address_ur: null,
        pharmcompany_address_post: null,
        pharmcompany_email: null,
        pharmcompany_tel: null,
        pharmcompany_inn: null,
        pharmcompany_kpp: null,
        pharmcompany_ogrnip: null,
        pharmcompany_ogrn: null,
        pharmcompany_bik: null,
        pharmcompany_bank_name: null,
        pharmcompany_corr_account: null,
        pharmcompany_bank_account: null,
        pharmcompany_chief_accountant: null,
      },
      orderDate: null,
      paymentWay: '100%',
      datePickerLabels: {
        ru: {
          labelPrevDecade: 'Пред. десятилетие',
          labelPrevYear: 'Пред. год',
          labelPrevMonth: 'Пред. месяц',
          labelCurrentMonth: 'Тек. месяц',
          labelNextMonth: 'След. месяц',
          labelNextYear: 'След. год',
          labelNextDecade: 'След. десятилетие',
          labelToday: 'Сегодня',
          labelSelected: 'Выбран',
          labelNoDateSelected: 'Дата не указана',
          labelCalendar: 'Календарь',
          labelNav: 'Навигация',
          labelHelp: 'Помощь'
        },
      }
    }),
    methods: {
      changeOrderDate () {
        console.log(this.orderDate)
      },
      onDiscountChange(index) {
        const product_discount_text = this.selectedProducts[index].product_discount_text ? Number(this.selectedProducts[index].product_discount_text) : 0
        //this.selectedProducts[index].product_discount = (100 - product_discount_text) / 100
        this.selectedProducts[index].cost_params.discount = product_discount_text
      },
      fillPcRekvizits () {
        const contex = this
        if (contex.selectedPcRekvizit === null) {
          contex.cleanPcRekvizits()
          return;
        }

        const rekvizit = contex.pharmCompanyRekvizits[contex.selectedPcRekvizit]

        if (rekvizit === undefined) return;

          contex.pcRekvizitParams.pharmcompany_name = rekvizit.pharmcompany_name
          contex.pcRekvizitParams.pharmcompany_director = rekvizit.pharmcompany_director
          contex.pcRekvizitParams.pharmcompany_director_akk = rekvizit.pharmcompany_director_akk
          contex.pcRekvizitParams.pharmcompany_director_occupation = rekvizit.pharmcompany_director_occupation
          contex.pcRekvizitParams.pharmcompany_address_ur = rekvizit.pharmcompany_address_ur
          contex.pcRekvizitParams.pharmcompany_address_post = rekvizit.pharmcompany_address_post
          contex.pcRekvizitParams.pharmcompany_email = rekvizit.pharmcompany_email
          contex.pcRekvizitParams.pharmcompany_tel = rekvizit.pharmcompany_tel
          contex.pcRekvizitParams.pharmcompany_inn = rekvizit.pharmcompany_inn
          contex.pcRekvizitParams.pharmcompany_kpp = rekvizit.pharmcompany_kpp
          contex.pcRekvizitParams.pharmcompany_ogrnip = rekvizit.pharmcompany_ogrnip
          contex.pcRekvizitParams.pharmcompany_ogrn = rekvizit.pharmcompany_ogrn
          contex.pcRekvizitParams.pharmcompany_bik = rekvizit.pharmcompany_bik
          contex.pcRekvizitParams.pharmcompany_bank_name = rekvizit.pharmcompany_bank_name
          contex.pcRekvizitParams.pharmcompany_corr_account = rekvizit.pharmcompany_corr_account
          contex.pcRekvizitParams.pharmcompany_bank_account = rekvizit.pharmcompany_bank_account
      },
      fillRekvizits () {
        const contex = this
        const rekvizit = contex.firmRekvizits.find(obj => {
          return obj.id === contex.selectedFirmRekvizit
        })

        contex.payerParams.title = rekvizit.name
        contex.payerParams.address = rekvizit.address_ur
        contex.payerParams.inn = rekvizit.inn
        contex.payerParams.kpp = rekvizit.kpp
        contex.payerParams.ogrn = rekvizit.ogrn
        contex.payerParams.bik = rekvizit.bik
        contex.payerParams.bank = rekvizit.bank_name
        contex.payerParams.corr_s = rekvizit.ks
        contex.payerParams.rs = rekvizit.rs
        contex.payerParams.phone = null
        contex.payerParams.email = null
        contex.payerParams.manager_name = rekvizit.fio
        contex.payerParams.manager_name_akk = rekvizit.fio_rod
        contex.payerParams.manager_position = rekvizit.post
        contex.payerParams.manager_position_akk = rekvizit.post_rod
        contex.shippingAddress = rekvizit.address_post
      },
      cleanUp () {
        this.selectedProducts = []
      },
      cleanPcRekvizits () {
        const contex = this

        contex.pcRekvizitParams.pharmcompany_name = null
        contex.pcRekvizitParams.pharmcompany_director = null
        contex.pcRekvizitParams.pharmcompany_director_akk = null
        contex.pcRekvizitParams.pharmcompany_director_occupation = null
        contex.pcRekvizitParams.pharmcompany_address_ur = null
        contex.pcRekvizitParams.pharmcompany_address_post = null
        contex.pcRekvizitParams.pharmcompany_email = null
        contex.pcRekvizitParams.pharmcompany_tel = null
        contex.pcRekvizitParams.pharmcompany_inn = null
        contex.pcRekvizitParams.pharmcompany_kpp = null
        contex.pcRekvizitParams.pharmcompany_ogrnip = null
        contex.pcRekvizitParams.pharmcompany_ogrn = null
        contex.pcRekvizitParams.pharmcompany_bik = null
        contex.pcRekvizitParams.pharmcompany_bank_name = null
        contex.pcRekvizitParams.pharmcompany_corr_account = null
        contex.pcRekvizitParams.pharmcompany_bank_account = null
      },
      updateOrder () {
        const contex = this

        let paymentWayTxt = ''
        switch (contex.paymentWay) {
          case null:
          case '':
          case '0%':
            paymentWayTxt = '100% от общей стоимости заказа в течение 10 дней после получения товара.'
            break;
          case '100%':
            paymentWayTxt = '100% от общей стоимости заказа в течение 10 дней с момента получения счета.'
            break;
          default:
            paymentWayTxt = contex.paymentWay + ' от общей стоимости заказа в течение 10 дней с момента получения счета, остальная часть в течение 10 дней после получения товара.'
            break;
        }

        const form = {
          order_id: contex.orderId,
          pharmacy_network_id: contex.selectedPharmacyNetworkId,
          address: contex.shippingAddress,
          payer_params: contex.payerParams,
          pc_rekvizits: contex.pharmCompanyRekvizits[contex.selectedPcRekvizit],
          order_date: contex.orderDate,
          payment_way: paymentWayTxt,
        }

        contex.apiCall(`orders/update`, 'post', form)
          .then(function (response) {

            if (response.data.status === 200 && response.data.errors.length === 0) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('OrderUpdated'), {
                title: contex.$ml.with('VueJS').get('UpdateOrder'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

              contex.$router.push({path: '/orders-list'})
              //contex.cleanUp()
            } else {
              let message = ''
              if (Array.isArray(response.data.errors)) {
                message = response.data.errors[0]
              } else {
                message = response.data.errors[Object.keys(response.data.errors)[0]]
              }
              contex.$bvToast.toast(`Ошибка: ${message}`, {
                title: contex.$ml.with('VueJS').get('CreateOrder'),
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            contex.$bvToast.toast(`Ошибка: ${error.response.data.message}`, {
              title: contex.$ml.with('VueJS').get('CreateOrder'),
              autoHideDelay: 5000,
              variant: 'danger',
              appendToast: false,
              toaster: 'b-toaster-bottom-right',
            })
          }).finally(function () {
        })
      },
      createOrder () {
        const contex = this

        let paymentWayTxt = ''
        switch (contex.paymentWay) {
          case null:
          case '':
          case '0%':
            paymentWayTxt = '100% от общей стоимости заказа в течение 10 дней после получения товара.'
            break;
          case '100%':
            paymentWayTxt = '100% от общей стоимости заказа в течение 10 дней с момента получения счета.'
            break;
          default:
            paymentWayTxt = contex.paymentWay + ' от общей стоимости заказа в течение 10 дней с момента получения счета, остальная часть в течение 10 дней после получения товара.'
            break;
        }

        if (contex.selectedProducts.length === 0) {
          contex.$bvToast.toast(contex.$ml.with('VueJS').get('ProductsListIsEmpty'), {
            title: contex.$ml.with('VueJS').get('CreateOrder'),
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: false,
            toaster: 'b-toaster-bottom-right',
          })

          return;
        }

        const form = {
          pharmacy_network_id: contex.selectedPharmacyNetworkId,
          address: contex.shippingAddress,
          payer_params: contex.payerParams,
          items: contex.selectedProducts,
          pc_rekvizits: contex.pharmCompanyRekvizits[contex.selectedPcRekvizit],
          order_date: contex.orderDate,
          payment_way: paymentWayTxt,
        }

        contex.apiCall(`orders/create`, 'post', form)
          .then(function (response) {

            if (response.data.status === 200 && response.data.errors.length === 0) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('OrderCreated'), {
                title: contex.$ml.with('VueJS').get('CreateOrder'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

              contex.$router.push({path: '/orders-list'})
              //contex.cleanUp()
            } else {
              let message = ''
              if (Array.isArray(response.data.errors)) {
                message = response.data.errors[0]
              } else {
                message = response.data.errors[Object.keys(response.data.errors)[0]]
              }
              contex.$bvToast.toast(`Ошибка: ${message}`, {
                title: contex.$ml.with('VueJS').get('CreateOrder'),
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
        })
      },
      addNewProduct () {
        this.selectedProducts.push({
          good_id: null,
          quantity: null,
          product_discount_text: null,
          product_discount: 1,
          cost_params: {
            discount: 0,
          }
        })
      },
      getProductsList () {
        const contex = this
        contex.productsList = []
        contex.apiCall(`products/list?per-page=1000`, 'post', {})
          .then(function (response) {
            /*if (response.status === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('DataSuccessfullyReceived'), {
                title: contex.$ml.with('VueJS').get('CreateOrder'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }*/

            const result = []
            for (let i = 0; i < response.data.items.length; i++) {
              result.push({
                value: response.data.items[i].id,
                text: `${response.data.items[i].apiGood.ru_name}`,
                enText: `${response.data.items[i].apiGood.en_name}`,
                pcUin: response.data.items[i].pcUin,
              })
            }
            contex.productsList = result
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {

        })
      },
      getFirmRekvizits (firmId) {
        const contex = this
        contex.firmRekvizits = []
        contex.apiCall(`firms/rekvizits-list?firmId=${firmId}`, 'post', {})
          .then(function (response) {
            /*if (response.status === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('DataSuccessfullyReceived'), {
                title: contex.$ml.with('VueJS').get('CreateOrder'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }*/

            const result = []
            for (let i = 0; i < response.data.length; i++) {
              result.push(response.data[i])
            }
            contex.firmRekvizits = result
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {

        })
      },
      getPharmacyNetworksList () {
        const contex = this
        contex.pharmacyNetworksList = []
        contex.apiCall(`firms/list`, 'post', {})
          .then(function (response) {
            /*if (response.status === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('DataSuccessfullyReceived'), {
                title: contex.$ml.with('VueJS').get('CreateOrder'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }*/

            const result = []
            for (let i = 0; i < response.data.items.length; i++) {
              result.push({
                value: response.data.items[i].phm_id,
                text: `${response.data.items[i].name}`
              })
            }
            contex.pharmacyNetworksList = result
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {

        })
      },
      getOrder (id) {
        const contex = this
        contex.apiCall(`orders/get?id=${id}`, 'post', {})
          .then(function (response) {
            const t = response.data.created_at.split(/[- :]/);
            const createdAt = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
            contex.orderDate = createdAt.toISOString().split('T')[0]

            if (response.data.order_params) {
              contex.shippingAddress = response.data.address
              contex.payerParams.title = response.data.order_params.payer_params.pharmacy_name
              contex.payerParams.address = response.data.order_params.payer_params.pharmacy_address
              contex.payerParams.inn = response.data.order_params.payer_params.pharmacy_inn
              contex.payerParams.kpp = response.data.order_params.payer_params.pharmacy_kpp
              contex.payerParams.ogrn = response.data.order_params.payer_params.pharmacy_ogrn
              contex.payerParams.bik = response.data.order_params.payer_params.pharmacy_bik
              contex.payerParams.bank = response.data.order_params.payer_params.pharmacy_bank_name
              contex.payerParams.corr_s = response.data.order_params.payer_params.pharmacy_corr_account
              contex.payerParams.rs = response.data.order_params.payer_params.pharmacy_bank_account
              contex.payerParams.phone = response.data.order_params.payer_params.pharmacy_phone
              contex.payerParams.email = response.data.order_params.payer_params.pharmacy_email
              contex.payerParams.manager_name = response.data.order_params.payer_params.pharmacy_manager_fullname
              contex.payerParams.manager_name_akk = response.data.order_params.payer_params.pharmacy_manager_fullname_akk
              contex.payerParams.manager_position = response.data.order_params.payer_params.pharmacy_manager_position
              contex.payerParams.manager_position_akk = response.data.order_params.payer_params.pharmacy_manager_position_akk

              contex.pcRekvizitParams.pharmcompany_name = response.data.order_params.pharmcompany.pharmcompany_name
              contex.pcRekvizitParams.pharmcompany_director = response.data.order_params.pharmcompany.pharmcompany_director
              contex.pcRekvizitParams.pharmcompany_director_akk = response.data.order_params.pharmcompany.pharmcompany_director_akk
              contex.pcRekvizitParams.pharmcompany_director_occupation = response.data.order_params.pharmcompany.pharmcompany_director_occupation
              contex.pcRekvizitParams.pharmcompany_address_ur = response.data.order_params.pharmcompany.pharmcompany_address_ur
              contex.pcRekvizitParams.pharmcompany_address_post = response.data.order_params.pharmcompany.pharmcompany_address_post
              contex.pcRekvizitParams.pharmcompany_email = response.data.order_params.pharmcompany.pharmcompany_email
              contex.pcRekvizitParams.pharmcompany_tel = response.data.order_params.pharmcompany.pharmcompany_tel
              contex.pcRekvizitParams.pharmcompany_inn = response.data.order_params.pharmcompany.pharmcompany_inn
              contex.pcRekvizitParams.pharmcompany_kpp = response.data.order_params.pharmcompany.pharmcompany_kpp
              contex.pcRekvizitParams.pharmcompany_ogrnip = response.data.order_params.pharmcompany.pharmcompany_ogrnip
              contex.pcRekvizitParams.pharmcompany_ogrn = response.data.order_params.pharmcompany.pharmcompany_ogrn
              contex.pcRekvizitParams.pharmcompany_bik = response.data.order_params.pharmcompany.pharmcompany_bik
              contex.pcRekvizitParams.pharmcompany_bank_name = response.data.order_params.pharmcompany.pharmcompany_bank_name
              contex.pcRekvizitParams.pharmcompany_corr_account = response.data.order_params.pharmcompany.pharmcompany_corr_account
              contex.pcRekvizitParams.pharmcompany_bank_account = response.data.order_params.pharmcompany.pharmcompany_bank_account
              contex.pcRekvizitParams.pharmcompany_chief_accountant = response.data.order_params.pharmcompany.pharmcompany_chief_accountant
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {

        })
      }

    },
    computed: {
      filteredProductsList: function () {
        const contex = this

        if (contex.selectedPcRekvizit === null) {
          return contex.productsList
        }
        const rekvizit = contex.pharmCompanyRekvizits[contex.selectedPcRekvizit]
        const result = [];
        for (let i = 0; i < contex.productsList.length; i++) {
          const item = contex.productsList[i]
          if (Number(item.pcUin) === Number(rekvizit.phm_id)) {
            result.push(item)
          }
        }

        return result
      }
    },
    watch: {
      selectedPharmacyNetworkId(val) {
        this.getFirmRekvizits(val)
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.orderId = Number(this.$route.params.id)
        this.getOrder(this.orderId)
      }
      if (!this.$store.state.isAuthenticated()) {
        this.$router.push({path: '/login'})
      }

      this.orderDate = new Date().toISOString().split('T')[0]

      this.getPharmacyNetworksList()
      this.getProductsList()
    }
  }
</script>